import { render, staticRenderFns } from "./datafields.vue?vue&type=template&id=55f5e24a&scoped=true&"
import script from "./datafields.vue?vue&type=script&lang=js&"
export * from "./datafields.vue?vue&type=script&lang=js&"
import style0 from "./datafields.vue?vue&type=style&index=0&id=55f5e24a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f5e24a",
  null
  
)

export default component.exports